import Modal from '../../../components/Modal';
import CustomizeCardImageUploader from '../../../components/CustomizeCardImageUploader';

const CustomizeCardModal = ({ onClose, onSelectCard, onComplete, isPhysical = false }) => {
  const handleComplete = async (croppedDataUrl) => {
    if (onComplete) {
      await onComplete(croppedDataUrl);
    } else if (onSelectCard) {
      await onSelectCard([croppedDataUrl]);
    }
  };

  return (
    <Modal
      onClose={onClose}
      breakpoints={[0, 0.75]}
      initialBreakpoint={0.75}
      cssClass="fixed-sheet-modal"
    >
      <CustomizeCardImageUploader
        isPhysical={isPhysical}
        onComplete={handleComplete}
        onCancel={onClose}
      />
    </Modal>
  );
};

export default CustomizeCardModal;
